import { c as _c } from "react/compiler-runtime";
import { Favourites as SharedFavourites } from "@catchy/ui";
import checkStopType from "@/lib/stopTypeChecker";
const resolveStopType = ({
  stop_id,
  stop_type,
  type
}) => stop_type || checkStopType(stop_id) || type;
export default function Favourites(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <SharedFavourites {...props} resolveStopType={resolveStopType} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}